module.exports = __webpack_public_path__ + "img/181.84eb5fd5.jpg";